import { createSlice } from '@reduxjs/toolkit';
import { DEVICE_TAB_TYPE } from "../constants";
var initialState = {
  activeTab: DEVICE_TAB_TYPE.deviceInformation,
  alias: null,
  isOpen: false
};
var devices = createSlice({
  initialState: initialState,
  name: 'devices',
  reducers: {
    closeDeviceModal: function closeDeviceModal(state) {
      state.alias = null;
      state.isOpen = false;
    },
    openDeviceModal: function openDeviceModal(state, _ref) {
      var payload = _ref.payload;
      state.alias = payload;
      state.isOpen = true;
    },
    setActiveTab: function setActiveTab(state, _ref2) {
      var payload = _ref2.payload;
      state.activeTab = payload;
    }
  }
});
export default devices.reducer;
var _devices$actions = devices.actions,
  closeDeviceModal = _devices$actions.closeDeviceModal,
  openDeviceModal = _devices$actions.openDeviceModal,
  setActiveTab = _devices$actions.setActiveTab;
export { closeDeviceModal, openDeviceModal, setActiveTab };